import { Component, Input } from "@angular/core";
import { SvgIcon, SvgIconMap } from "@ponder-shared/utils/svgIcons";
import { PreviewItemComponent } from "../preview-item.component";
import { getMagicCardRoute } from "@ponder-features/magic/card/magicCardRouter";

@Component({
    selector: "preview-item-context-open-tab",
    imports: [],
    templateUrl: "./preview-item-context-menu-open-tab.component.html"
})
export class PreviewItemContextMenuOpenTabComponent {
    @Input({ required: true }) previewItem!: PreviewItemComponent;
    
    public readonly svgIcon: string = SvgIconMap.get(SvgIcon.OpenTab)!;
    public itemUrl!: string;

    public constructor() {

    }

    public ngOnInit(): void {
        this.itemUrl = getMagicCardRoute(this.previewItem.previewItem.item.data!.magic!);
    }

    public ngOnChanges(): void {
        this.itemUrl = getMagicCardRoute(this.previewItem.previewItem.item.data!.magic!);
    }
}